export class CommunicationDetails {
    streetName: string;
    city: string;
    primaryAddress: boolean;
    zipCode: string;
    houseNumber: string;
    stateProvince: string;
    extraInfo: string;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/communication/details/communication-details.model.ts